import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function NotFound() {
  useEffect(() => {
    document.title = 'Not found — Sonologue'
  }, [])

  return (
    <div className="card">
      <div className="empty-state">
        <h1>Nothing at this address</h1>
        {/* Written for both audiences. Until `signed-out-not-found` moved the
            catch-all into `OpenLayout`, this page was unreachable without a
            session, so the old sentence could assume the reader was signed in
            and inside the app. A stranger who mistyped a URL now sees it too. */}
        <p>
          This page doesn’t exist. The link may be mistyped or out of date. If something looks
          broken, tell us.
        </p>
        <Link className="btn btn-tonal" to="/">
          Go home
        </Link>
      </div>
    </div>
  )
}
